<template>
  <Summary
    :date-from="dateFrom"
    :date-to="dateTo"
    :imei="imei"
    :vehicle="vehicle"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import Summary from '@/components/content/_partials/history/Summary.vue'

export default defineComponent({
  name: 'SummaryView',
  components: { Summary },
  props: {
    imei: BigInt as unknown as PropType<bigint>,
    dateFrom: String,
    dateTo: String,
    vehicle: Object,
    reportType: String
  }
})
</script>